<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Delete Project</h1>
      <p>
        To delete a project from the user's account, the user must first navigate to the projects page.
        From there, after the project to be deleted is located, by pressing the corresponding project's
        <i class="fas fa-trash" /> <b>delete button</b>, a modal will appear asking the user if they would like to proceed
        with the removal of the project. If the user confirms the action, the project is deleted.
      </p>

      <p class="text-red-accent-4 text-lg-body-1">
        <b>
          <i class="fas fa-warning"/> Warning! Once this action is confirmed it cannot be undone. The project will be
          deleted with all its KPIs/PSIs and will be unable to be recovered by anyone, even the developers.
        </b>

      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-delete-button.png" alt="delete button location" />
        <div class="img-caption">
          Figure 1. Delete Project button's location.
        </div>
      </div>

      <div class="image-container">
        <img src="@/images/manual/delete-project-prompt.png" alt="project delete prompt" />
        <div class="img-caption">
          Figure 2. The prompt shown once pressed.
        </div>
      </div>


    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
